
export enum WaterLossCauseEnum {
    LineBreak3rdParty = 1,
    LineBreakNon3rdParty = 2,
    UnauthorizedUsage = 3,
    FireDepartment = 4,
    SystemMaintenance = 5,
    Other = 6
}
